var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9.17969 7.95703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 7.95703,
    opacity: 0,
    width: 9.17969,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17969 3.97656C9.17578 3.51953 8.55469 3.1875 7.80859 3.1875L6.23438 3.1875C6.01562 3.1875 5.93359 3.15234 5.80469 3.00391L3.17969 0.140625C3.09766 0.046875 2.99609 0 2.87891 0L2.42578 0C2.32422 0 2.26562 0.0898438 2.31641 0.199219L3.66797 3.1875L1.68359 3.41406L0.976562 2.11719C0.925781 2.01953 0.839844 1.97656 0.710938 1.97656L0.542969 1.97656C0.441406 1.97656 0.375 2.04297 0.375 2.14453L0.375 5.80859C0.375 5.91016 0.441406 5.97266 0.542969 5.97266L0.710938 5.97266C0.839844 5.97266 0.925781 5.92969 0.976562 5.83594L1.68359 4.53906L3.66797 4.76562L2.31641 7.75391C2.26562 7.85938 2.32422 7.95312 2.42578 7.95312L2.87891 7.95312C2.99609 7.95312 3.09766 7.90234 3.17969 7.8125L5.80469 4.94531C5.93359 4.80078 6.01562 4.76562 6.23438 4.76562L7.80859 4.76562C8.55469 4.76562 9.17578 4.42969 9.17969 3.97656Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.32dcd390020ab6201bbafd866edc5246.svg";
export { ForwardRef as ReactComponent };